
<template>
	<div class="calls-table-cell" :class="columnClass">
        <div v-if="columnLabel=='employee_name'&&!recurringUnavailability(employee.available_times)&&!getDeclineStatus(employee.call_actions)&&!getCallOutStatus(employee.call_actions)" class="table-td-border-right">
            <div class="calls-table-cell-inner-table o-modal-trigger" data-toggle="modal" data-target="#employeeSummaryModal">

                <div class="o-accordion-subtext o-rowtable-text">

                    <div>{{(selectedSortType=='fname_asc')?employee.first_name+" "+employee.last_name : employee.last_name+", "+employee.first_name}}</div>
                </div>
            </div>
        </div>

        <div v-if="columnLabel=='employee_seniority'&&!recurringUnavailability(employee.available_times)&&!getDeclineStatus(employee.call_actions)&&!getCallOutStatus(employee.call_actions)" class="table-td-border-right">
            <div class="o-accordion-subtext o-rowtable-text">

                <div>{{ getRoundOffSkillSeniority(employee.employee_seniority) || 0}}</div>
            </div>
        </div>

        <!-- <div v-if="columnLabel=='skill_seniority'&&!recurringUnavailability(employee.available_times)&&!getDeclineStatus(employee.call_actions)&&!getCallOutStatus(employee.call_actions)" class="table-td-border-right">
            <div class="o-accordion-subtext o-rowtable-text">

                <div>{{ getRoundOffSkillSeniority(employee.skill_seniority) || 0 }}</div>
            </div>
        </div> -->

        <div v-if="columnLabel=='shift_count_ytd'&&!recurringUnavailability(employee.available_times)&&!getDeclineStatus(employee.call_actions)&&!getCallOutStatus(employee.call_actions)" class="table-td-border-right">
            <div class="o-accordion-subtext o-rowtable-text">
                <div>{{employee.total_shift_YTD || '0' }}</div>
            </div>
        </div>

        <div v-if="columnLabel=='shift_count_total'&&!recurringUnavailability(employee.available_times)&&!getDeclineStatus(employee.call_actions)&&!getCallOutStatus(employee.call_actions)" class="table-td-border-right">
            <div class="o-accordion-subtext o-rowtable-text">
                <div>{{employee.total_shifts || '0' }}</div>
            </div>
        </div>

        <div v-if="columnLabel=='shifts_this_week'&&!recurringUnavailability(employee.available_times)&&!getDeclineStatus(employee.call_actions)&&!getCallOutStatus(employee.call_actions)" class="table-td-border-right">
            <div class="o-accordion-subtext o-rowtable-text">
                <div>{{employee.total_shift_weekly || '0' }}</div>
            </div>
        </div>

        <div v-if="columnLabel=='shifts_ytd_july_june'&&!recurringUnavailability(employee.available_times)&&!getDeclineStatus(employee.call_actions)&&!getCallOutStatus(employee.call_actions)" class="table-td-border-right">
            <div class="o-accordion-subtext o-rowtable-text">
                <div>{{employee.total_decline_july_june || '0' }}</div>
            </div>
        </div>

        <div v-if="columnLabel=='declines_total'&&!recurringUnavailability(employee.available_times)&&!getDeclineStatus(employee.call_actions)&&!getCallOutStatus(employee.call_actions)" class="table-td-border-right">
            <div class="o-accordion-subtext o-rowtable-text">
                <div>{{employee.total_decline || '0' }}</div>
            </div>
        </div>

        <div v-if="columnLabel=='declines_ytd'&&!recurringUnavailability(employee.available_times)&&!getDeclineStatus(employee.call_actions)&&!getCallOutStatus(employee.call_actions)" class="table-td-border-right">
            <div class="o-accordion-subtext o-rowtable-text">
                <div>{{employee.total_decline_YTD || '0' }}</div>
            </div>
        </div>

        <div v-if="columnLabel=='declines_ytd_july_june'&&!recurringUnavailability(employee.available_times)&&!getDeclineStatus(employee.call_actions)&&!getCallOutStatus(employee.call_actions)" class="table-td-border-right">
            <div class="o-accordion-subtext o-rowtable-text">
                <div>{{employee.total_decline_july_june || '0' }}</div>
            </div>
        </div>

        <div v-if="columnLabel=='decline_this_week'&&!recurringUnavailability(employee.available_times)&&!getDeclineStatus(employee.call_actions)&&!getCallOutStatus(employee.call_actions)" class="table-td-border-right">
            <div class="o-accordion-subtext o-rowtable-text">
                <div>{{employee.total_decline_weekly || '0' }}</div>
            </div>
        </div>

        <div v-if="columnLabel=='participation'&&!recurringUnavailability(employee.available_times)&&!getDeclineStatus(employee.call_actions)&&!getCallOutStatus(employee.call_actions)" class="table-td-border-right">
            <div class="o-accordion-subtext o-rowtable-text">
                <div>{{getParticipation(employee.participation)}} %</div>
            </div>
        </div>

        <div v-if="columnLabel=='participation_july_june_desc'&&!recurringUnavailability(employee.available_times)&&!getDeclineStatus(employee.call_actions)&&!getCallOutStatus(employee.call_actions)" class="table-td-border-right">
            <div class="o-accordion-subtext o-rowtable-text">
                <div>{{getParticipation(employee.participation_july_june)}} %</div>
            </div>
        </div>

        <div v-if="columnLabel=='last_offer'&&!recurringUnavailability(employee.available_times)&&!getDeclineStatus(employee.call_actions)&&!getCallOutStatus(employee.call_actions)" class="table-td-border-right">
            <div class="o-accordion-subtext o-rowtable-text">
                 <div>
                {{employee.last_offer ? getGlobalDateTimeFormat(employee.last_offer) : ""}}
            </div>
            </div>
        </div>

        <div v-if="columnLabel=='location'&&!recurringUnavailability(employee.available_times)&&!getDeclineStatus(employee.call_actions)&&!getCallOutStatus(employee.call_actions)" class="table-td-border-right">
            <div class="o-accordion-subtext o-rowtable-text">
                <div>{{employee.address || '- - -'}}</div>
                <!-- <div>Add Location</div> -->
            </div>
        </div>

        <!-- <div v-if="columnLabel=='wishlist'&&!recurringUnavailability(employee.available_times)&&!getDeclineStatus(employee.call_actions)&&!getCallOutStatus(employee.call_actions)" class="table-td-border-right calls-table-cell-inner-table">
            <div class="o-accordion-subtext o-rowtable-text">
                <span>Wishlist: <i :class="(employee.wishlist.length==0)?'fa fa-star fa-star--disable':((employee.wishlist[0].type !='W')? 'fa fa-ban' : 'fa fa-star')" aria-hidden="true"></i></span>
                <div>{{(employee && employee.wishlist.length)? getTimeStampValue(employee.wishlist[0].wishlist_timing):''}}</div>
            </div>
        </div> -->

        <div v-if="columnLabel=='custom_field1'&&!recurringUnavailability(employee.available_times)&&!getDeclineStatus(employee.call_actions)&&!getCallOutStatus(employee.call_actions)" class="table-td-border-right">
            <div class="o-accordion-subtext o-rowtable-text">
                <div>{{getCustomField(employee.custom_field1)}}</div>
            </div>
        </div>

        <div v-if="columnLabel=='custom_field2'&&!recurringUnavailability(employee.available_times)&&!getDeclineStatus(employee.call_actions)&&!getCallOutStatus(employee.call_actions)" class="table-td-border-right">
            <div class="o-accordion-subtext o-rowtable-text">
                <div>{{getCustomField(employee.custom_field2)}}</div>
            </div>
        </div>
        

        <div v-if="columnLabel=='employee_cell_phone'&&!recurringUnavailability(employee.available_times)&&!getDeclineStatus(employee.call_actions)&&!getCallOutStatus(employee.call_actions)" class="table-td-border-right">
            <div class="o-accordion-subtext o-rowtable-text">
                <!-- <div>{{(employee.employable.phones && employee.employable.phones.length>0)? employee.employable.phones[0].phone_number :'--' }}</div> -->
                    <div>
                        <a :href="'tel:'+getClientContactFormat(employee.phone_number)" class="phone-number-display">
                            {{ employee.phone_number ? getClientContactFormat(employee.phone_number) : '' }}
                        </a>
                        <!-- {{employee.phone_number || '- - -'}} -->
                    </div>
            </div>
        </div>
        
        <div v-if="columnLabel=='conflicts'&&!recurringUnavailability(employee.available_times)&&!getDeclineStatus(employee.call_actions)&&!getCallOutStatus(employee.call_actions)">
            <div v-if="recurringUnavailability(employee.available_times)" class="table-td-border-right calls-table-cell-inner-table">
                <div class="o-tags u-no-padding text-right o-tag-btn-container">
                    <ul class="o-tag-btn-area o-float-right">
                        <li class="o-half-div">
                            <a href="javascript: void(0)" class="c-tag-btn u-btn-red">
                                {{ 
                                    'Unavailable due to Recurring Unavailability'
                                }}
                            </a>
                        </li>
                    </ul>
                </div>
            </div>

            <div v-else-if="employee.bookings.length == 0 && !recurringUnavailability(employee.available_times) && !getDeclineStatus(employee.call_actions) && !getPassStatus(employee.call_actions) && !getTimeOutStatus(employee.call_actions) && !getCallOutStatus(employee.call_actions)" class="table-td-border-right calls-table-cell-inner-table">
                
                <div class="o-tags u-no-padding text-right o-tag-btn-container">
                    <ul v-if="!getDeclineStatus(employee.call_actions) && !getPassStatus(employee.call_actions)" class="o-tag-btn-area o-float-right">

                        <li v-if="Object.keys(employee.previous_calls).length==0" :class="{'o-half-div': true}">
                            <a href="javascript: void(0)" :class="{'c-tag-btn u-btn-green':!employee.hts_conflict,'c-tag-btn u-btn-light-orange':employee.hts_conflict }">
                                <span> Last call 24:00+</span>
                            </a>
                        </li>

                        <li v-if="Object.keys(employee.previous_calls).length!=0" :class="{'o-half-div': true}">
                            <a href="javascript: void(0)" :class="{ 'c-tag-btn u-btn-green':!employee.hts_conflict && !checkTurnOver(employee.previous_calls), 'c-tag-btn u-btn-light-orange':employee.hts_conflict && checkTurnOver(employee.previous_calls), 'c-tag-btn u-btn-light-orange':employee.hts_conflict && !checkTurnOver(employee.previous_calls)}">
                                <span> {{ getPrevCallTime(employee.previous_calls) }}</span>
                            </a>
                        </li>

                        <!-- <li v-if="employee.hts_conflict" class="o-half-div o-half-div-width">
                            <a href="javascript: void(0)" class="c-tag-btn u-btn-light-orange">{{getJobTitle(employee.hts_conflict)}}</a>
                        </li> -->
                        
                        <li v-if="Object.keys(employee.next_calls).length==0" :class="{'o-half-div':  true}">
                            <a href="javascript: void(0)" :class="{'c-tag-btn u-btn-green':!employee.hts_conflict, 'c-tag-btn u-btn-light-orange':employee.hts_conflict}">
                                <span>Next call 24:00+</span>
                            </a>
                        </li>

                        <li v-if="Object.keys(employee.next_calls).length!=0" :class="{'o-half-div':  true}">
                            <a href="javascript: void(0)" :class="{'c-tag-btn u-btn-green':!employee.hts_conflict && !checkTurnOver(employee.next_calls),'c-tag-btn u-btn-light-orange':employee.hts_conflict && checkTurnOver(employee.next_calls)}">
                                <span>{{getNextCallTime(employee.next_calls)}} </span>
                            </a>
                        </li>
                    </ul>
                </div>
            </div>

             <!-- <div v-if="!recurringUnavailability(employee.available_times)&&!getDeclineStatus(employee.call_actions)&&!getCallOutStatus(employee.call_actions)&&employee.booking_conflicts.length >0" class="table-td-border-right calls-table-cell-inner-table"> -->
            <div v-else-if="employee.bookings.length>0&&!recurringUnavailability(employee.available_times)&&!getDeclineStatus(employee.call_actions)&&!getCallOutStatus(employee.call_actions)" class="table-td-border-right calls-table-cell-inner-table">
                <div class="o-tags u-no-padding text-right o-tag-btn-container">
                    <ul class="o-tag-btn-area o-float-right">
                        <li class="o-half-div" v-if="!checkAssignedJob(employee)">
                            <a href="javascript: void(0)" :class="checkThisClickCooking(employee.bookings)?'c-tag-btn u-btn-orange':'c-tag-btn u-btn-red'">
                            {{checkThisClickCooking(employee.bookings)?employee.bookings[0].job_name+ ':' +getConflictDate(employee.bookings[0].start)+'('+getTime(employee.bookings[0].start) +'-'+ getTime(employee.bookings[0].end)+')':'OTHER BOOKING'}}
                            </a>
                        </li>

                        <li class="o-half-div" v-else>
                            <a href="javascript: void(0)" class="c-tag-btn u-btn-blue">
                            {{employee.bookings[0].job_name+ ':' +getConflictDate(employee.bookings[0].start)+'('+getTime(employee.bookings[0].start) +'-'+ getTime(employee.bookings[0].end)+')'}}
                            </a>
                        </li>
                    </ul>
                </div>
            </div> 

            <div v-else-if="!recurringUnavailability(employee.available_times)&&!getDeclineStatus(employee.call_actions)&&!getCallOutStatus(employee.call_actions)" class="table-td-border-right calls-table-cell-inner-table">
                <div class="o-tags u-no-padding text-right o-tag-btn-container">
                    <ul v-if="getDeclineStatus(employee.call_actions)" class="o-tag-btn-area o-float-right">
                        <li class="o-half-div" @click="openDeclinedModal(employee)"><a href="javascript: void(0)" class="c-tag-btn u-btn-red">Declined : {{getCallActionByType(employee.call_actions, "Declined")[0].job_name}}</a></li>
                    </ul>
                    
                    <ul v-else-if="!getDeclineStatus(employee.call_actions) && getCallOutStatus(employee.call_actions) && !getTimeOutStatus(employee.call_actions)" class="o-tag-btn-area o-float-right">
                        <li class="o-half-div"><a href="javascript: void(0)" class="c-tag-btn u-btn-yellow">Called Out : {{getCallActionByType(employee.call_actions, "Call Out")[0].job_name}}</a></li>
                    </ul>
                    <ul v-else-if="!getDeclineStatus(employee.call_actions) && getTimeOutStatus(employee.call_actions) && !getPassStatus(employee.call_actions)" class="o-tag-btn-area o-float-right">
                        <li class="o-half-div"><a href="javascript: void(0)" class="c-tag-btn u-btn-yellow">Timed Out : {{getCallActionByType(employee.call_actions, "Timed Out")[0].job_name}}</a></li>
                    </ul>
                    <ul v-else-if="!getDeclineStatus(employee.call_actions) && getPassStatus(employee.call_actions)" class="o-tag-btn-area o-float-right">
                        <li class="o-half-div"><a href="javascript: void(0)" class="c-tag-btn u-btn-yellow">Passed : {{getCallActionByType(employee.call_actions, "Passed")[0].job_name}}</a></li>
                    </ul>
                </div>
            </div>
        </div>
	</div>
</template>

<script>
    import dateTimeConvert from '../../../timeConvert&Compare';
    import {
        mapGetters,
        mapActions
    } from 'vuex';
    import {
        global
    } from '../../../global.js';
    import { bus } from '../../../main';
    import service from '../../../services.js';
    export default {
        props: {
            employee: {
                type: Object,
                required: true
            },
            columnLabel: {
                type: String,
                required: true
            },
            client:{
                type: Object,
                required: true
            },
            selectedSortType:{
                type: String,
                required: true
            },
            callStartTime:{
                type:String,
                required: true
            },
            callEndTime:{
                type:String,
                required: true
            },
            userDateFormat: {
                type:String,
                required: false
            },
            userTimeFormat: {
                type:String,
                required: false
            }
        },
        data() {
            return {
               columnClass:'',
               turnoverTime: '',
                customField1: '',
                customField2: '',
                showCustom: '',
                ignore_decline: '',
                address:'',
            }
        },
        computed: {
            ...mapGetters({
                userToken: 'userToken',
                userRole: 'userRole',
                userClientID: 'userClientID',
                userID: 'userID',
                userRoleSlug: 'userRoleSlug',
                // callDate: 'callDate',
            })
        },
        methods: {
            getClientContactFormat(phone) {
                phone = phone ? phone.toString() : '';
                phone = phone.replace(/-/g, "");
                phone = phone.replace(/ /g, "");
                phone = phone.replace("(", "");
                phone = phone.replace(")", "");
                let result = '';
                if(phone&&phone.length==10) { 
                    // console.log(phone);
                    result = '+1'+phone;
                }else if(phone&&phone.length==11) {
                    // console.log(phone);
                    result = '+' + phone;
                }else if(phone&&phone.length) {
                    result = phone;
                }
                return result;
                // return phone;
            },
            getRoundOffSkillSeniority(seniorityVal) {     
                // console.log(seniorityVal); 
                if(seniorityVal && seniorityVal != '') {          
                    if(seniorityVal.valueOf() == parseInt(seniorityVal)){
                        let x = parseInt(seniorityVal);
                        return x;
                    }
                }
                return seniorityVal;
            },
            async openDeclinedModal(emp) {
                // console.log('This call Declined');
                // console.log(emp);
                if(this.userRoleSlug != 'employee') {
                    await this.$confirm('Do you want to Un-Decline', 'Un-Decline?', {
                    confirmButtonText: 'Undecline',
                    cancelButtonText: 'Cancel',
                    }).then(async () => {
                        await this.undeclinedCall(emp);
                    }).catch(() => {});
                }
            },
            
            async undeclinedCall(emp) {
                // console.log(emp);
                
                await service.post('call/undecline', {
                    'employee_id': emp.id,
                    'call_id': emp.call_actions[0].call_id,
                    'user_id': this.userID
                }, {
                    'Authorization': this.userToken,
                    'cs3-context-role': this.userRole,
                    'cs3-context-clientId': this.userClientID,
                }).
                then((res) => {
                    let action = 'Decline'
                    // console.log(res)
                    this.$Progress.finish();
                    this.$notify({
                        title: 'Success',
                        message: 'Call undeclined successfully.',
                        type: 'success'
                    });
                    bus.$emit('callUnDecline', action );
                }).catch((err) => {
                    console.log(err);
                    this.$notify({
                        title: 'Warning',
                        message: 'Call undeclined Failed.',
                        type: 'warning'
                    });
                    this.$Progress.finish();
                });
            },
            
            isCurrentJobHTS(hts_list){
                if(hts_list && !Array.isArray(hts_list)){
                    hts_list=Object.values(hts_list)
                }
                let flag=false;
                hts_list.forEach(hts => {
                    // console.log(hts.job_id, atob(this.$route.params.id));
                    if(hts.job_id == atob(this.$route.params.id)){
                        flag=true;
                    }
                });
                return flag;
            },
            getJobTitle(hts_list){
                if(hts_list && !Array.isArray(hts_list)){
                    hts_list=Object.values(hts_list)
                }
                // console.log('hts_list',hts_list);
                return (hts_list && hts_list.length? hts_list[0].job_name :'');
            },
            getCallActionByType(call_action, type){
                let declines = [], passes = [], timeouts = [], callouts = [];
                if(call_action && call_action.length){
                    call_action.forEach(call => {
                        switch(call.action_name){
                            // decline Call
                            case 'Declined':
                                declines.push(call);
                            break;
                            // call out
                            case 'Call Out':
                                callouts.push(call);
                            break;
                            // Call time out
                            case 'Timed Out':
                                timeouts.push(call);
                            break;
                            // pass call
                            case 'Passed':
                                passes.push(call);
                            break;                          
                           
                            default:
                                // console.log('call Action not found switch 1')
                        }
                    });
                }
                switch(type){
                    // decline Call
                    case 'Declined':
                        return declines;
                    break;
                    // call out
                    case 'Call Out':
                        return callouts;
                    break;
                    // Call time out
                    case 'Timed Out':
                        return timeouts;
                    break;
                    // pass call
                    case 'Passed':
                        return passes;
                    break;
                    
                    default:
                        // console.log('call Action not found switch 2')
                }
                return [];
            },
            checkThisClickCooking(bookings,conflicts){
                if(conflicts) console.log(conflicts);
                // console.log(bookings[0].client_id); 
                // console.log(this.userClientID); 
               if(bookings.length>0 && bookings[0].client_id == this.userClientID){
                    return true;
                }
                return false; 
                //  if(bookings.length == 0 && conflicts.length > 0 && conflicts[0]){
                //     return false;
                // }
                // return true;
            },

            checkAssignedJob(employee) {
                let bookings = employee.bookings;
                if(bookings.length>0 && bookings[0].client_id == this.userClientID &&  bookings[0].job_id == atob(this.$route.params.id)){
                    return true;
                }
                return false; 
            },

            getParticipation(data){
                var result = 0;
                //console.log('Data',data);
                if(data != null && data != '')
                    result = Math.round(Number(data).toFixed(2) * 100) / 100;
                return result;
            },

            getDeclineStatus(call_actions){
                let data = this.getCallActionByType(call_actions, "Declined");
                if((data.length>0 || Object.keys(data).length>0) && this.ignore_decline!=1){
                    return true;
                }
                return false;                
            },

            getTimeStampValue(data){
                //console.log('getTimeStampValue',data)
                if(data)  return dateTimeConvert.utcTimeToUserTime(data);
                return '- - -';
            },

            getTimeStamp(data){
                //console.log('getTimeStampValue',data)
                if(data)  return moment(data).format('MM/DD/YYYYY @HH:mm:ss');
                return '- - -';
            },

            getGlobalDateTimeFormat(date1) {
                // return date1;
                return dateTimeConvert.globalDateTime(date1,this.userDateFormat,this.userTimeFormat);
            },

            getPassStatus(call_actions){
                let data = this.getCallActionByType(call_actions, "Passed");
                // console.log(data);
                // console.log(Object.keys(data).length);
                // console.log(this.ignore_decline);
                if ((data.length > 0 || Object.keys(data).length>0) && this.ignore_decline != 1) {
                    return true;
                } 
                return false;
            },

            getTimeOutStatus(call_actions){
                let data = this.getCallActionByType(call_actions, "Timed Out");
                if ((data.length > 0 || Object.keys(data).length>0) && this.ignore_decline != 1) {
                    return true;
                } 
                return false;
            },

            getCallOutStatus(call_actions){
                let data = this.getCallActionByType(call_actions, "Call Out");
                // console.log(data);
                // console.log(Object.keys(data).length);
                // console.log(this.ignore_decline);
                if ((data.length > 0 || Object.keys(data).length>0) && this.ignore_decline != 1) {
                    return true;
                } 
                return false;
            },

            getCustomField(data) {
                // var customFld = JSON.parse(data);
                // return customFld.value;
                var customFld = JSON.parse(data);
                let re = -1;
                let re2 = -1;
                if(customFld && customFld.value)
                {
                    re = customFld.value.search('{\"name\":');
                    let inner = "";
                    if(re>=0) {
                        inner = JSON.parse(customFld.value);
                        console.log(inner);
                        if(inner&&inner != ''&&inner.value)
                            re2 = customFld.value.search('{\"name\":')
                        if(inner.value == "{}" || inner.value == "NULL" || inner.value == "null" || inner.value == "Null" || re2>=0)
                            return '';
                        return inner.value;
                    }else
                    return customFld&&customFld.value&& customFld.value !='{}' && customFld.value !='NULL' && customFld.value!='Null' && customFld.value != 'null' ? customFld.value : '';  
                }
                return ""; 
            },

            employeeSummary() {
                this.$modal.show('employeeSummary');
            },

            hideModal() {
                this.$modal.hide();
            },

            getTime(dateTime) {
                return dateTimeConvert.globalTime(dateTime);
            },

            getConflictDate(dateTime) {
                return dateTimeConvert.withCustomFormat(dateTime, 'DD MMM');
            },

            // getTurnOverNext(dateTime, turnover){
            //     var startDate = moment(dateTime, "YYYY-MM-DD HH:mm:ss");
            //     var endDate = moment(this.callStartTime, "YYYY-MM-DD HH:mm:ss");// another date
            //     var duration = moment.duration(startDate.diff(endDate));
            //     var result = duration.asMinutes();
            //     result=(result>0)?result:result*-1;
            //     // return result/60;
            //     if(result>Number(turnover)*60)
            //         return false;
            //     else
            //         return true;  
            // },
            // getTurnOverPrev(dateTime, turnover){
            //     var startDate = moment(this.callEndTime, "YYYY-MM-DD HH:mm:ss");
            //     var endDate = moment(dateTime, "YYYY-MM-DD HH:mm:ss");
            //     var duration = moment.duration(startDate.diff(endDate));
            //     var result = duration.asMinutes();
            //     result=(result>0)?result:result*-1;
            //     // return result/60;
            //     if(result>Number(turnover)*60)
            //         return false;
            //     else
            //         return true;     
            // },
            
            checkTurnOver(calls){
                if(calls && Object.keys(calls).length){
                    let duration = calls[0].call_interval?calls[0].call_interval.split(':'):[];
                    if(duration.length>=2 && Number(duration[0]) <= 24){
                        let hours =  Number(duration[0]);
                        if(hours < this.turnoverTime){
                            return true;
                        }
                    }
                }
                return false;
            },

            getPrevCallTime(calls) {
                if(calls && Object.keys(calls).length){
                    let duration = calls[0].call_interval?calls[0].call_interval.split(':'):[];
                    if(duration.length >= 3 && Number(duration[0]) < 24){
                        return 'Last call '+moment(calls[0].call_interval, 'HH:mm:ss').format('HH:mm')+'+';
                    }
                }
                return "Last call 24:00+";
            },
            getNextVacationAndCallTime(vacation,calls) {
                let result1 = '';
                let result2 = '';
                if(calls && Object.keys(calls).length){
                    let duration = calls[0].call_interval?calls[0].call_interval.split(':'):[];
                    if(duration.length >= 3 && Number(duration[0]) < 24){
                        result1 =  'Next call '+moment(calls[0].call_interval, 'HH:mm:ss').format('HH:mm')+'+';
                    }
                }
                if(vacation && Object.keys(vacation).length){
                    let duration = vacation[0].vacation_interval.split(':');
                    if(duration.length >= 3 && Number(duration[0]) < 24){
                        result2 = 'Next vacation: '+moment(vacation[0].vacation_interval, 'HH:mm:ss').format('HH:mm')+'+';
                    }
                }
                return result1 + ', ' + result2;
            },

            getNextVacationTime(calls) {
                if(calls && Object.keys(calls).length){
                    let duration = calls[0].vacation_interval.split(':');
                    if(duration.length >= 3 && Number(duration[0]) < 24){
                        return 'Next vacation '+moment(calls[0].vacation_interval, 'HH:mm:ss').format('HH:mm')+'+';
                    }
                }
                return "Next call 24:00+";
            },
            getNextCallTime(calls) {
                if(calls && Object.keys(calls).length){
                    let duration = calls[0].call_interval.split(':');
                    if(duration.length >= 3 && Number(duration[0]) < 24){
                        return 'Next call '+moment(calls[0].call_interval, 'HH:mm:ss').format('HH:mm')+'+';
                    }
                }
                return "Next call 24:00+";
            },

            recurringUnavailability(unavailability_list) {
                var flag=false;               
                let weekDaysNumbers = ["1","2","3","4","5","6","7"];
                let weekDaysNames = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
                if(unavailability_list && Object.keys(unavailability_list).length){
                    let unavailabilityList = JSON.parse(unavailability_list);
                    for(let i=0; i<weekDaysNumbers.length; i++) {
                        let unavailabilityList1=unavailabilityList[weekDaysNumbers[i]];  
                        for(var j=1; j<=Object.keys(unavailabilityList1).length; j++){
                            // console.log(unavailabilityList1[j])
                            var temp = unavailabilityList1[j];
                            var start = this.callStartTime.split(' ')[0]+' '+temp[0]+':00';
                            var end = this.callStartTime.split(' ')[0]+' '+temp[1]+':00';
                            // console.log("start: ",start);
                            // console.log("end: ",end);

                            let overnightUnavailability = moment(start,'YYYY-MM-DD HH:mm:ss').isAfter(moment(end,'YYYY-MM-DD HH:mm:ss'));

                            if(overnightUnavailability) {  
                                // console.log("check1");
                                if(start.split(' ')[0] == end.split(' ')[0]) {  
                                    // console.log("check2")    
                                    end = moment(end, 'YYYY-MM-DD HH:mm:ss').add(1, "d").format("YYYY-MM-DD HH:mm:ss"); 
                                }                                    
                                if(this.callStartTime.split(' ')[0] == this.callEndTime.split(' ')[0]) {
                                    if(moment(this.callStartTime,'YYYY-MM-DD HH:mm:ss').format('dddd') == weekDaysNames[i+1]) {
                                        let flag1 = dateTimeConvert.dateCheck(start,end, this.callStartTime, this.callEndTime);
                                        return flag1;
                                    }
                                } else {
                                    end = this.callStartTime.split(' ')[0]+' '+temp[1]+':00';
                                    // if(start.split(' ')[0] == end.split(' ')[0]) {
                                    //     // console.log("check2");                                    
                                    //     end = moment(end, 'YYYY-MM-DD HH:mm:ss').add(1, "d").format("YYYY-MM-DD HH:mm:ss");
                                    // }
                                    if(moment(this.callStartTime,'YYYY-MM-DD HH:mm:ss').format('dddd') == weekDaysNames[i]) {
                                        // console.log("Check3");
                                        let flag1 = dateTimeConvert.dateCheck(start,end, this.callStartTime, this.callEndTime);
                                        return flag1;
                                    }else if(moment(this.callEndTime,'YYYY-MM-DD HH:mm:ss').format('dddd') == weekDaysNames[i+1]){
                                        // console.log("Check4");
                                        let flag1 = dateTimeConvert.dateCheck(start,end, this.callStartTime, this.callEndTime);
                                        return flag1;
                                    }
                                }

                                let overNightUnavailabilityEnd = moment(end, 'YYYY-MM-DD HH:mm:ss').add(1, "d").format("DD-MM-YYYY");

                                overNightUnavailabilityEnd = overNightUnavailabilityEnd + ' '+temp[1]+':00';

                                if(weekDaysNames[i] == (moment(overNightUnavailabilityEnd,'YYYY-MM-DD HH:mm:ss').format('dddd'))) {
                                    let flag1 = dateTimeConvert.dateCheck(start,overNightUnavailabilityEnd, this.callStartTime, this.callEndTime);
                                    return flag1;
                                }
                            }

                        }
                    }
                    return this.recurringUnavailability1(unavailability_list);
                }
                return flag;
            },

            checkCallDateUnavailability(date, unavailabilityList1) {
               
            },

            recurringUnavailability1(unavailability_list){        
                let flag=false;
                if(unavailability_list && Object.keys(unavailability_list).length){
                    let unavailabilityList = JSON.parse(unavailability_list);
                    let dayNum1=moment(this.callStartTime).format('d');
                                       
                    dayNum1=Number(dayNum1)+1;
                    let unavailabilityList1=unavailabilityList[dayNum1];  
                    for(var i=1; i<=Object.keys(unavailabilityList1).length; i++){
                        var temp = unavailabilityList1[i];
                        var start = this.callStartTime.split(' ')[0]+' '+temp[0]+':00';
                        var end = this.callStartTime.split(' ')[0]+' '+temp[1]+':00';                                               
                        if(dateTimeConvert.dateCheck(start, end, this.callStartTime, this.callEndTime)){
                            flag=true;
                            return flag;
                        }
                    }
                    let dayNum2=moment(this.callEndTime).format('d');
                    dayNum2=Number(dayNum2)+1;
                    if(this.callStartTime.split(' ')[0] != this.callEndTime.split(' ')[0]) {
                        let unavailabilityList2=unavailabilityList[dayNum2];
                        for(var i=1; i<=Object.keys(unavailabilityList2).length; i++){
                            var temp = unavailabilityList2[i];
                            var start = this.callEndTime.split(' ')[0]+' '+temp[0]+':00';
                            var end = this.callEndTime.split(' ')[0]+' '+temp[1]+':00';                                                  
                            if(dateTimeConvert.dateCheck(start, end, this.callStartTime, this.callEndTime)){
                                flag=true;
                                return flag;
                            }
                        }
                    }
                }
                return flag;
            },
            checkVacationWithinCall(vacations) {

                if(vacations.length>0){
                    //console.log('vacations',vacations);
                    // var startDate = vacations[0].start;
                    // var endDate = vacations[0].end;

                    // if(dateTimeConvert.dateCheck(startDate, endDate, this.callStartTime) || dateTimeConvert.dateCheck(startDate, endDate, this.callEndTime)){
                    //     //console.log('true',vacations);
                    //     return true;
                    // }else{
                    //     return false;
                    // } 
                    return true;
                }else{
                    return false;
                }
            },
        },
        created() {
            switch(this.columnLabel){
                // case "skill_seniority":
                //     this.columnClass='tcell_5'
                //     break;
                case "shift_count_total":
                    this.columnClass='tcell_4'
                    break;
                case "shift_count_ytd":
                    this.columnClass='tcell_4'
                    break;
                case "declines_total":
                    this.columnClass='tcell_4'
                    break;
                case "declines_ytd":
                    this.columnClass='tcell_4'
                    break;
                case "declines_ytd_july_june":
                    this.columnClass='tcell_4'
                    break;
                case "shifts_this_week":
                    this.columnClass='tcell_4'
                    break;
                case "employee_cell_phone":
                    this.columnClass='tcell_4'
                    break;
                case "employee_name":
                    this.columnClass='tcell_4'
                    break;
                case "conflicts":
                    this.columnClass='tcell_7'
                    break;
                case "shifts_ytd_july_june":
                    this.columnClass='tcell_4'
                    break;
                case "location":
                    this.columnClass='tcell_5'
                    break;
                case "decline_this_week":
                    this.columnClass='tcell_4'
                    break;
                case "participation":
                    this.columnClass='tcell_4'
                    break;
                case "participation_july_june_desc":
                    this.columnClass='tcell_4'
                    break;
                case "last_offer":
                    this.columnClass='tcell_4'
                    break;
                // case "wishlist":
                //     this.columnClass='tcell_3'
                //     break;
                case "employee_seniority":
                    this.columnClass='tcell_4'
                    break;
                case "custom_field1":
                    this.columnClass='tcell_4'
                    break;
                case "custom_field2":
                    this.columnClass='tcell_4'
                    break;
            }      
            this.turnoverTime = this.client.turnover;
            // this.selectedSortType = this.client.default_sort;
            this.customField1 = this.client.custom_field_1;
            this.customField2 = this.client.custom_field_2;
            this.showCustom = this.client.call_assignment_title;
            this.ignore_decline = this.client.ignore_decline;
            this.callAssigmentSettings = this.client.settings['call-assignment-config'];
        }

    }

</script>
<style scoped>
.phone-number-display{
    padding: 5px;
    cursor: pointer;
    color: #222222;
    text-decoration: none !important;
}
.u-btn-blue {
    background: #37bae8!important;
}

.u-btn-yellow1 {
    background: #e8e000bf!important;
}
.o-half-div-width{
    width: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/calls/assign/dynamicColumns911Availability.vue